<template>
  <div class="MessageContent">
    <v-spacer v-if="!isUser"></v-spacer>
    <div class="message-text-container">
      <div class="message-text" :class="isUser ? 'user' : 'bot'">
        <span v-html="replaceLinkInTextContent(content.text)" class="text-pre"></span>
        <span v-if="needViewMore && showViewMore" @click="toggleViewMore" class="view-more">
                    {{ $t('viewMore') }}
                </span>
      </div>
      <div>
        <button class="message-btn-quick" v-for="(b, ib) in content.buttons" :key="ib">
          {{ b.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
  name: "MessageContentRating",
  extends: MessageContent
}
</script>

